export const compact = (array: any) => array?.filter((item: any) => !!item);
